import "./styles/ModalWindow.css";
import { DominoesStore } from "../../Stores/DominoesStore";
import { HelpModalWindow } from "../HelpModalWindow";
import { DominoButton } from "../../Components/StyledComponents/DominoButton";
import React from "react";
import { InsideDomino } from "./InsideDomino";

interface PropsModalWindow {
  dominoesStore: DominoesStore;
  imageConnectElem: string;
  onModalClose: () => void;
}

/** Modal window */
export const ModalWindow: React.FC<PropsModalWindow> = ({
  dominoesStore,
  imageConnectElem,
  onModalClose,
}) => {
  return (
    <HelpModalWindow
      onCloseClick={onModalClose}
      windowClassName="domino-app"
      cards={
        <>
          <div>
            <span>Первая фишка - с пустым полем слева:</span>
            <DominoButton disabled>
              <InsideDomino
                content={dominoesStore.firstDomino}
                isModalWindow={true}
              />
            </DominoButton>
          </div>
          <div>
            <span>Последняя фишка - с пустым полем справа:</span>
            <DominoButton disabled>
              <InsideDomino
                content={dominoesStore.lastDomino}
                isModalWindow={true}
              />
            </DominoButton>
          </div>
          <div>
            <span>
              По клику на фишку она становится на первое свободное место в
              цепочке фишек в верхнем поле.
            </span>
            <DominoButton isFree={true} disabled></DominoButton>
          </div>
          <div>
            <span>
              Если фишка в цепочку встала верно, то появляется соединительный
              элемент.
            </span>
            <img
              className="connect-elem-for-modal-window"
              src={imageConnectElem}
            ></img>
          </div>
          <div>
            <span>
              Если фишка в цепочку встала неверно, нельзя выбрать следующую
              фишку.
            </span>
            <span className="text-is-not-right-for-modal-window">Неверно</span>
          </div>
          <div>
            <span>
              По клику на неверно поставленную фишку она возвращается на прежнее
              место.
            </span>
          </div>
          <div>
            <span>
              Существует только один единственно верный вариант сбора цепочки.
            </span>
          </div>
        </>
      }
    />
  );
};
